import React, { useState } from 'react';
import {
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Collapse,
  Divider,
  ClickAwayListener,
} from '@mui/material';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import Logo from './Logo.tsx';

interface MobileDrawerProps {
  onClose: () => void;
  onNavigate: (route: string) => void;
}

const pages = ['Home', 'Services', 'Locations', 'Check Balance', 'Schedule Now'];

const MobileDrawer: React.FC<MobileDrawerProps> = ({ onClose, onNavigate }) => {
  const [servicesOpen, setServicesOpen] = useState(false);

  const toggleServices = (e: React.MouseEvent) => {
    e.stopPropagation();
    setServicesOpen((prev) => !prev);
  };

  const handleNavigate = (route: string) => {
    onNavigate(route);
    onClose();
  };

  return (
    <Box sx={{ textAlign: 'center', py: 3, px: 2 }}>
      {/* Logo */}
      <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
        <Logo onClick={() => handleNavigate('/')} height={130} />
      </Box>
      <List sx={{ width: '100%' }}>
        {pages.map((page, index) => (
          <React.Fragment key={page}>
            {page === 'Services' ? (
              // Wrap the Services section with ClickAwayListener to collapse when clicking outside
              <ClickAwayListener onClickAway={() => setServicesOpen(false)}>
                <Box>
                  <ListItem disablePadding>
                    <ListItemButton
                      onClick={toggleServices}
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        px: 3,
                        fontWeight: 'bold',
                      }}
                    >
                      <ListItemText primary="Services" sx={{ textAlign: 'left' }} />
                      {servicesOpen ? <ExpandLess /> : <ExpandMore />}
                    </ListItemButton>
                  </ListItem>
                  <Collapse in={servicesOpen} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding sx={{ pl: 4 }}>
                      <ListItem disablePadding>
                        <ListItemButton onClick={() => window.open('https://www.mylaundryorder.com/?s=1740758514200x273776307348996480', '_blank', 'width=600,height=800')}>
                          <ListItemText primary="Order Now" sx={{ textAlign: 'left' }} />
                        </ListItemButton>
                      </ListItem>
                      <Divider sx={{ mx: 3 }} />
                      <ListItem disablePadding>
                        <ListItemButton onClick={() => handleNavigate('/all-services')}>
                          <ListItemText primary="All Services" sx={{ textAlign: 'left' }} />
                        </ListItemButton>
                      </ListItem>
                      <ListItem disablePadding>
                        <ListItemButton onClick={() => handleNavigate('/menu-dropoff')}>
                          <ListItemText primary="Wash & Fold Prices (Drop Off)" sx={{ textAlign: 'left' }} />
                        </ListItemButton>
                      </ListItem>
                    </List>
                  </Collapse>
                </Box>
              </ClickAwayListener>
            ) : (
              <ListItem disablePadding>
                <ListItemButton
                  sx={{ px: 3, fontWeight: 'bold', textAlign: 'left' }}
                  onClick={() => {
                    if (page === 'Check Balance') {
                      window.open(
                        'https://my.laundroworks.com/',
                        '_blank',
                        'width=600,height=800'
                      );
                    } else if (page === 'Schedule Now') {
                      window.open(
                        'https://www.mylaundryorder.com/?s=1740758514200x273776307348996480',
                        '_blank',
                        'width=600,height=800'
                      );
                    } else {
                      handleNavigate(
                        page.toLowerCase() === 'home'
                          ? '/'
                          : `/${page.toLowerCase().replace(' ', '-')}`
                      );
                    }
                  }}
                >
                  <ListItemText
                    primary={page}
                    sx={{
                      fontWeight: page === 'Schedule Now' ? 'bold' : 'normal',
                      color: page === 'Schedule Now' ? 'primary.main' : 'text.primary',
                      backgroundColor: page === 'Schedule Now' ? 'background.default' : 'transparent',
                      borderRadius: page === 'Schedule Now' ? 1 : 0,
                      px: page === 'Schedule Now' ? 1 : 0,
                    }}
                  />                   
                  </ListItemButton>
              </ListItem>
            )}
            {index !== pages.length - 1 && <Divider sx={{ mx: 3 }} />}
          </React.Fragment>
        ))}
      </List>
    </Box>
  );
};

export default MobileDrawer;
